var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.261,
    height: 12.538,
    viewBox: "0 0 12.261 12.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M11.487,12.406,9.57,10.494a5.9,5.9,0,1,1,.664-.621l1.9,1.89a.454.454,0,0,1-.641.643ZM.908,5.892A4.985,4.985,0,1,0,5.893.908,4.99,4.99,0,0,0,.908,5.892Z",
    transform: "translate(0 0)",
    fill: "#9a9a9a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.836ec075718ddedbc9c2433db484bf7d.svg";
export { ForwardRef as ReactComponent };